/* @ngInject */
function appConfig ($httpProvider, $locationProvider, $translateProvider) {
  $httpProvider.defaults.withCredentials = true

  if (!window.devEnv) {
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    })
  }

  // security purposes
  $translateProvider.useSanitizeValueStrategy('escaped')

  $translateProvider.determinePreferredLanguage(function () {
    // get the language of the browser or language selected by user
    var sLocaleLanguage = null

    if (window.localStorage) {
      sLocaleLanguage = window.localStorage.getItem('preferredLanguage')
    }

    var sLanguage = sLocaleLanguage || window.navigator.userLanguage || window.navigator.language

    if (sLanguage.substring(0, 2).toUpperCase() === 'PT') {
      return 'pt-BR'
    } else if (sLanguage.substring(0, 2).toUpperCase() === 'ES') {
      return 'es-ES'
    } else {
      return 'en-US'
    }
  })

  $translateProvider.useStaticFilesLoader({
    prefix: '/assets/i18n/',
    suffix: '.json?$$REVISION$$'
  })

  $translateProvider.fallbackLanguage('en-US')
}

export const deskfyConfig = appConfig
